// removed by extract-text-webpack-plugin
module.exports = {"minicart":"c-Minicart__minicart","label":"c-Minicart__label","quantity":"c-Minicart__quantity","withLabel":"c-Minicart__withLabel"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/Minicart/Minicart.scss
// module id = 889
// module chunks = 0